import { useState } from "react";

export default function MovieShare({ title }: { title: string }) {
  const [tip, setTip] = useState("");
  const shareUrl = typeof window !== "undefined" ? window.location.href : "";
  const weiboLink = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
    shareUrl,
  )}&title=${encodeURIComponent(`推荐电影《${title}》 - 九七电影院`)}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setTip("链接已复制，可粘贴分享给好友");
    } catch {
      setTip("复制失败，请手动复制浏览器地址");
    }
    setTimeout(() => setTip(""), 2500);
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="text-sm text-foreground-500">分享到：</span>
      <a
        href={weiboLink}
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
      >
        <i className="ri-weibo-line"></i>微博
      </a>
      <button
        type="button"
        onClick={() => setTip("请使用微信「扫一扫」或复制下方链接进行分享")}
        className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
      >
        <i className="ri-wechat-line"></i>微信
      </button>
      <button
        type="button"
        onClick={copyLink}
        className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
      >
        <i className="ri-link"></i>复制链接
      </button>
      {tip && (
        <span className="absolute -top-9 left-0 rounded-md bg-foreground-900 px-3 py-1.5 text-xs text-background-50">
          {tip}
        </span>
      )}
    </div>
  );
}